import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.trim";

/**
 * @license frenchkiss 0.2.1
 * Copyright (c) 2018-2019 Koala Interactive, Inc.
 * License: MIT
 */
var t = /^\s*\w+\s*$/,
    e = /^\s*(\w+)\s*,\s*(select|plural)\s*,/i,
    n = JSON.stringify,
    s = function s(t) {
  return '(p["' + t + '"]||(p["' + t + '"]=="0"?0:"' + t + '" in p?"":v("' + t + '",k,l)))';
};

function o(t) {
  var e = {},
      o = function t(e, o) {
    var l = [];
    var r = e.length;

    for (var _c = 0; _c < r; ++_c) {
      var _r = e[_c],
          _f = _r[0],
          _i = _r[1];
      var _u = "";
      if (0 === _f && _i) _u = n(_i);else if (1 === _f) _u = s(_i.trim());else if (2 === _f) {
        var _e = _r[2],
            _s = _r[3],
            _l = _r[4],
            _c2 = _s.length;

        for (var _r2 = 0; _r2 < _c2; ++_r2) {
          _l ? "=" === _s[_r2][0][0] ? _u += 'p["' + _e + '"]==' + n(_s[_r2][0].substr(1)) : (o[_e] = 1, _u += 'm["' + _e + '"]==' + n(_s[_r2][0])) : _u += 'p["' + _e + '"]==' + n(_s[_r2][0]), _u += "?" + t(_s[_r2][1], o) + ":";
        }

        _u = "(" + _u + t(_i, o) + ")";
      }
      _u && l.push(_u);
    }

    return l.join("+") || '""';
  }(l(t), e),
      r = Object.keys(e),
      c = r.length,
      f = [];

  for (var _t = 0; _t < c; ++_t) {
    f[_t] = r[_t] + ':f(p["' + r[_t] + '"])';
  }

  return Function("a", "f", "k", "l", "v", "var p=a||{}" + (c ? ",m=f?{" + f + "}:{}" : "") + ";return " + o);
}

function l(n) {
  var s = 0,
      o = "";
  var l = n.length,
      c = [];

  for (var _f2 = 0; _f2 < l; ++_f2) {
    var _l2 = n[_f2];

    var _i2 = void 0;

    "{" === _l2 ? s++ || (_i2 = [0, o]) : "}" === _l2 && (--s || (_i2 = t.test(o) ? [1, o] : e.test(o) ? r(o) : [0, o])), _i2 ? (c.push(_i2), o = "") : o += _l2;
  }

  return c.push([0, o]), c;
}

function r(t) {
  var n = t.match(e),
      s = n[1],
      o = "p" === n[2][0].toLowerCase(),
      r = l(t.replace(e, "")),
      c = r.length,
      f = [];
  var i = [0, ""];

  for (var _t2 = 0; _t2 < c - 1;) {
    var _e2 = r[_t2++][1].trim();

    var _n = l(r[_t2++][1]);

    "other" === _e2 ? i = _n : o && "=" === _e2[0] ? f.unshift([_e2, _n]) : f.push([_e2, _n]);
  }

  return [2, i, s, f, o];
}

var c = {},
    f = {};

var i = {},
    u = "",
    p = "",
    a = function a(t) {
  return t;
},
    h = function h() {
  return "";
};

var g = function g(t, e) {
  return c[e] && c[e][t] || f[e] && "string" == typeof f[e][t] && (c[e][t] = o(f[e][t]));
},
    b = function b(t, e, n) {
  var s,
      o = n || u;
  return o && (s = g(t, o)) ? s(e, i[o], t, o, h) : (o = p) && (s = g(t, o)) ? s(e, i[o], t, o, h) : a(t, e, n || u);
},
    y = function y(t) {
  a = t;
},
    d = function d(t) {
  h = t;
},
    j = function j(t) {
  return t && (u = t), u;
},
    k = function k(t) {
  return t && (p = t), p;
},
    m = function m(t, e) {
  O(e, e, ""), c[t] = {}, f[t] = e;
},
    O = function O(t, e, n) {
  var s = Object.keys(e),
      o = s.length;

  for (var _l3 = 0; _l3 < o; ++_l3) {
    var _o = s[_l3],
        _r3 = n + _o;

    "object" == typeof e[_o] ? (O(t, e[_o], _r3 + "."), delete t[_o]) : t[_r3] = e[_o] + "";
  }
},
    v = function v(t, e) {
  i[t] = e;
},
    w = function w(t, e) {
  f[t] || (f[t] = {}), c[t] || (c[t] = {}), x(f[t], c[t], e, "");
},
    x = function x(t, e, n, s) {
  var o = Object.keys(n),
      l = o.length;

  for (var _r4 = 0; _r4 < l; ++_r4) {
    var _l4 = o[_r4],
        _c3 = s + _l4;

    "object" == typeof n[_l4] ? x(t, e, n[_l4], _c3 + ".") : t[_c3] !== n[_l4] && (delete e[_c3], t[_c3] = n[_l4] + "");
  }
},
    M = function M(t) {
  delete c[t], delete f[t];
};

export default {
  cache: c,
  store: f,
  t: b,
  onMissingKey: y,
  onMissingVariable: d,
  locale: j,
  fallback: k,
  set: m,
  unset: M,
  extend: w,
  plural: v
};
export { c as cache, f as store, b as t, y as onMissingKey, d as onMissingVariable, j as locale, k as fallback, m as set, v as plural, w as extend, M as unset };